import { render, staticRenderFns } from "./modalCategorias.vue?vue&type=template&id=4d95d920&scoped=true"
import script from "./modalCategorias.vue?vue&type=script&lang=js"
export * from "./modalCategorias.vue?vue&type=script&lang=js"
import style0 from "./modalCategorias.vue?vue&type=style&index=0&id=4d95d920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d95d920",
  null
  
)

export default component.exports